export enum RunnableLookupCopyState {
  NoCopy = 0,
  Copy = 1,
  CopyWithValues = 2
}
